









































































import Vue from 'vue'
import axios from 'axios'
import TitleName from '../atoms/TitleName.vue'
import ModalPanel from '../atoms/ModalPanel.vue'
import SubmitFlow from '../organisms/SubmitFlow.vue'

export type DataType = {
  loginId: string,
  password: string,
  errorMessage: string,
}
export default Vue.extend({
  components: {
    TitleName,
    ModalPanel,
    SubmitFlow
  },
  data(): DataType {
    return {
      loginId: '',
      password: '',
      errorMessage: ''
    }
  },
  mounted() {
    this.$store.dispatch('getCurrentDate')
    this.$store.commit('user/logout')
  },
  async created() {
    // サーバ側の現在時刻を取得
    this.$store.dispatch('getCurrentDate')
  },
  computed: {
    lostPasswordUrl(): string {
      return `${process.env.VUE_APP_ROOT_PATH}/participant/forgot-id-or-password`
    },
    questionPageUrl(): string {
      return `${process.env.VUE_APP_ROOT_PATH}/participant/faq/`
    },
    isOverPeriod(): boolean {
      if (!process.env.VUE_APP_VISITER_SIGNIN_PERIOD_TO) {
        return false
      }
      return new Date(process.env.VUE_APP_VISITER_SIGNIN_PERIOD_TO) < new Date(this.$store.state.currentDate)
    }
  },
  methods: {
    async signIn() {
      let res = null
      try {
        res = await axios.post('/api/v1/auth/sign_in', {
          email: this.loginId,
          password: this.password,
        })
      } catch(e) {
        // 401 etc
      }
      if (!res || res.data.success == false) {
        return this.errorMessage = 'ログインに失敗しました。メールアドレスとパスワードを確認してください。'
      }
      // 成功時の処理
      this.$store.dispatch('saveSubmitTestVisiterAuth', { response: res })

      this.$router.push('/tensaku_visiter/')

    }
  }
})
